export default "__VITE_ASSET__ziynRdAz__"